export const generateHealthSummary = (conditions, surgeries, medications, rules) => {
  const messages = [];

  rules.forEach(rule => {
    const keyword = rule.keyword.toLowerCase();

    // Match conditions
    if (rule.type === "condition" && conditions.some(c => c.condition_name.toLowerCase().includes(keyword))) {
      messages.push(rule.message);
    }

    // Match surgeries
    if (rule.type === "surgery" && surgeries.some(s => s.surgery_name.toLowerCase().includes(keyword))) {
      messages.push(rule.message);
    }

    // Match medications
    if (rule.type === "medication" && medications.some(med => med.drug_name.toLowerCase().includes(keyword))) {
      messages.push(rule.message);
    }
  });

  return messages;
};
